(function ($, Drupal) {
  Drupal.behaviors.mpel = {
    attach: function attach(context) {
      MP.UrlLang='mp_js_current_lang';
      MP.SrcUrl=decodeURIComponent('mp_js_orgin_url');
      MP.oSite=decodeURIComponent('mp_js_origin_baseUrl');
      MP.tSite=decodeURIComponent('mp_js_translated_baseUrl');
      MP.init();
      var mpelCookieComplianceHasLoadedScripts = false;

      $('#mpel-language-toggle, #mpel-mobile-language-toggle').bind('click', function(event) {
        event.preventDefault();

        var scriptTag = document.createElement('script');
        scriptTag.src='https://dennyscom.mpeasylink.com/mpel/mpel_chooser.js';
        document.body.appendChild(scriptTag);
        window.scroll({top:0, left:0, behavior:'smooth'});

        return false;
      });
    }
  }
})(jQuery, Drupal);
